module.exports = __webpack_public_path__ + "static/img/MEA.afcc3955.png";